/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import template from './folder-list-page.component.html';

import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../common/controller/signal-admin-resource-list-state';
import {FolderApiService, FolderModel} from './folder-api.service';
import {UIRouterModule} from '@uirouter/angular';
import {AppSharedModule} from '../common/app-shared.module';
import {SignalAdminResourceListComponent} from '../common/controller/signal-admin-resource-list.component';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-folder-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FolderListPageComponent implements OnInit {
  readonly itemStateName = 'app.dat-seg.folders.folder';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {label: 'folderId', param: '', sortable: false}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<FolderModel>(
    inject(FolderApiService),
    {listId: 'fullFolderList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
